import type { TrackingEvent } from '../types';

/** Snowplow 自定义事件在触发时捕获的页面原子字段。 */
export interface SnowplowAtomicPageProperties {
  page: string;
  url: string;
  refr: string;
}

/** 只在 ReportingCenter 与 Snowplow Provider 之间传递页面快照的不可枚举存储。 */
const snowplowAtomicPagePropertiesByEvent = new WeakMap<
  TrackingEvent,
  SnowplowAtomicPageProperties
>();

/** 创建互不共享引用的页面原子字段副本。 */
function cloneAtomicPageProperties(
  properties: SnowplowAtomicPageProperties,
): SnowplowAtomicPageProperties {
  return { ...properties };
}

/** 在业务调用时同步且 SSR 安全地捕获当前页面字段。 */
export function captureSnowplowAtomicPageProperties(): SnowplowAtomicPageProperties {
  return {
    page: typeof document === 'undefined' ? '' : document.title || '',
    url:
      typeof window === 'undefined' || typeof window.location?.href !== 'string'
        ? ''
        : window.location.href,
    refr: typeof document === 'undefined' ? '' : document.referrer || '',
  };
}

/** 将页面快照绑定到事件对象，但不改变事件的 JSON 或业务 properties。 */
export function registerSnowplowAtomicPageProperties(
  event: TrackingEvent,
  properties: SnowplowAtomicPageProperties,
): void {
  snowplowAtomicPagePropertiesByEvent.set(event, cloneAtomicPageProperties(properties));
}

/** 读取事件已绑定的页面快照；不存在时返回 null。 */
export function readSnowplowAtomicPageProperties(
  event: TrackingEvent,
): SnowplowAtomicPageProperties | null {
  const properties = snowplowAtomicPagePropertiesByEvent.get(event);
  return properties ? cloneAtomicPageProperties(properties) : null;
}
